import { usePostComposer } from 'app/modules/posts/modules/post/components/composer/PostComposerProvider';
import { usePostExperienceSwitch } from 'app/modules/posts/modules/post/hooks/usePostExperienceSwitch';

export function useLegacyPostExperienceSwitch() {
  const { form, savePost } = usePostComposer();

  return usePostExperienceSwitch({
    current: 'legacy',
    postId: form.id,
    pageId: form.page.id,
    hasUnsavedChanges: () => true,
    saveDraft: async () => (await savePost({ closeAfterSave: false }))?.id,
  });
}
